module.exports = __webpack_public_path__ + "static/media/tsbkz.fbcc6391.pdf";